import React, { useEffect, useState } from "react";
import axios from "axios";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Helmet } from "react-helmet-async";

import { useNavigate } from "react-router-dom";
import { Form, FormGroup } from "@govtechsg/sgds-react/Form";
import { FormCheck } from "@govtechsg/sgds-react/Form";
import { Button } from "@govtechsg/sgds-react/Button";
import { Card } from "@govtechsg/sgds-react/Card";
// import { Col, Row } from '@govtechsg/sgds-react'
import { Toast, ToastContainer } from "@govtechsg/sgds-react";
import { handleEvtClicks } from "./helper";

// Components
import HeaderRegComponent from "../Components/HeaderRegComponent";
import FooterComponent from "../Components/FooterComponent";

// Images
import img_onemap_attr from "../images/logo/round/omi_logo_attr@2x.png";

const Register = () => {
  const navigate = useNavigate();
  const [showCard, setShowCard] = useState(false);
  const [showTextBox, setShowTextBox] = useState(false);
  const [ack, setAck] = useState("");
  const [selectedUserGroup, setSelectedUserGroup] = useState("");
  const [selectedSubUserGroup, setSelectedSubUserGroup] = useState("");
  const [selectedAPI, setSelectedAPI] = useState("");
  const [selectedLearn, setSelectedLearn] = useState("");
  const [labelChange, setLabelChange] = useState("");
  const [APIUsageOthers, setAPIUsageOthers] = useState("");
  const [otherUserGroupText, setOthersUserGroupText] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [registeredUser, setRegisteredUser] = useState({
    firstName: "",
    lastName: "",
    pass: "",
    email: "",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    var fName = e.target[0].value;
    var lName = e.target[1].value;
    var company = encodeURIComponent(e.target[2].value);
    var email = e.target[3].value;

    const token = await executeRecaptcha("register");

    var regDetails = {
      fname: fName,
      lname: lName,
      orgname: company,
      email: email,
      acceptancePDN: true,
      account_group: selectedUserGroup,
      account_sub_group: selectedSubUserGroup,
      account_group_others: otherUserGroupText,
      api_usage_type: selectedAPI,
      usage_desc: encodeURIComponent(APIUsageOthers),
      account_referral: selectedLearn,
      recaptchaBody: token,
    };

    setRegisteredUser(regDetails);

    //Debug API
    apiRegisterUserAddtionalData(regDetails, true);

    // Prod API
    //apiRegisterUserAddtionalData(regDetails);
  };

  const apiRegisterUserAddtionalData = (regDetails, isDebug = false) => {
    let _headers = {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    };

    // const _path = 'https://omi-gcc.smartgeo.sg/'
    axios
      .post(`${process.env.REACT_APP_REGISTRATION}`, regDetails, _headers)
      // axios.post(`${process.env.REACT_APP_PUBLIC_URL}api/public/user/registerUserTest`, regDetails, _headers)
      .then((res) => {
        const { status } = res;
        if (status === 200 && !res.data.error) {
          new handleEvtClicks("APIRegistration", {
            Status: "RegistrationSuccess",
          });
          // navigate(`${process.env.REACT_APP_PUBLIC_URL}/registerconfirm`, {
          //   state: { email: regDetails.email },
          // });
          navigate("/registerconfirm", {
            state: { email: regDetails.email },
          });
        }
      })
      .catch((err) => {
        // console.log(err, "err");
        const {
          response: { status, data },
        } = err;

        if (status === 400 && data.message === "Recaptcha score is low") {
          showToastMessage(
            "Please refresh and try again or contact OneMap for support",
          );
        } else if ((status === 400 || status === 404) && data.error.email) {
          showToastMessage(
            data.error.email
              ? data.error.email +
                  " Please contact OneMap if you have not verified your email."
              : "Please contact OneMap if you have not verified your email.",
          );
        } else if ((status === 400 || status === 404) && data.message) {
          //if (status === 400 || status === 404)
          showToastMessage(data.message);
        } else if ((status === 400 || status === 404) && data.error) {
          showToastMessage(
            data.error + " Please contact OneMap for assistance",
          );
        }
      });
  };

  const saveUserGroupChange = () => {
    setShowCard(false);
  };

  const handleUserGroupChange = (e) => {
    if (e.target.value === "business") {
      setShowCard(true);
      setSelectedUserGroup(e.target.value);
      setShowTextBox(false);
      setLabelChange(labelChange);
    } else if (e.target.value === "others") {
      setSelectedUserGroup(e.target.value);
      setShowTextBox(true);
      setLabelChange("");
      setShowCard(false);
    } else {
      setSelectedUserGroup(e.target.value);
      setSelectedSubUserGroup("");
      setLabelChange("");
      setShowCard(false);
      setShowTextBox(false);
    }
  };

  // handle sub business change
  const subBusinessChange = (e) => {
    if (e.target.value === "real estate") {
      setLabelChange(` - Real Estate`);
      setSelectedSubUserGroup(e.target.value);
    } else if (e.target.value === "logistic") {
      setSelectedSubUserGroup(e.target.value);
      setLabelChange(" - Logistics");
    } else if (e.target.value === "finance") {
      setSelectedSubUserGroup(e.target.value);
      setLabelChange(" - Finance");
    } else if (e.target.value === "geospatial") {
      setSelectedSubUserGroup(e.target.value);
      setLabelChange(" - Geospatial");
    } else if (e.target.value === "others") {
      setSelectedSubUserGroup(e.target.value);
      setLabelChange(" - Others");
    }
  };

  const APIUsageChange = (e) => {
    setSelectedAPI(e.target.value);
  };

  const LearnOptionsChange = (e) => {
    setSelectedLearn(e.target.value);
  };

  const othersTextChange = (e) => {
    setOthersUserGroupText(e.target.value);
  };

  const subBusinessGroup = [
    { label: "Real Estate", value: "real estate", name: "ug-biz" },
    { label: "Logistics", value: "logistic", name: "ug-biz" },
    { label: "Finance", value: "finance", name: "ug-biz" },
    { label: "Geospatial", value: "geospatial", name: "ug-biz" },
    { label: "Others", value: "others", name: "ug-biz" },
  ];

  const UserGroupOptions = [
    { label: "Business", value: "business", name: "ug" },
    { label: "Government Agency", value: "government agencies", name: "ug" },
    { label: "Education", value: "education", name: "ug" },
    { label: "Others", value: "others", name: "ug" },
  ];

  const APIUsageOptions = [
    { label: "Mobile Application", value: "mobile app", name: "api" },
    { label: "Website", value: "website", name: "api" },
    { label: "Research / Student Projects", value: "education", name: "api" },
    { label: "Others", value: "others", name: "api" },
  ];

  const LearnOptions = [
    { label: "Google Search", value: "google search", name: "learn" },
    { label: "Word of mouth", value: "word of mouth", name: "learn" },
    { label: "Social Media", value: "social media", name: "learn" },
    { label: "Others", value: "others", name: "learn" },
  ];

  const ackChange = (e) => {
    setAck(e.target.value);
  };

  const APIUsageOthersChange = (e) => {
    setAPIUsageOthers(e.target.value);
  };

  const [showToast, setShowToast] = useState(false);

  const [toastText, _setToastText] = useState("");

  const showToastMessage = (_text) => {
    _setToastText(_text);

    setShowToast(true);
  };

  const ToastComponent = () => {
    return (
      <ToastContainer>
        <Toast
          className="om-warning"
          show={showToast}
          onClose={() => setShowToast(false)}
        >
          <Toast.Header>
            <img src={img_onemap_attr} className="rounded me-2" alt="OneMap" />
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>
            <small>{toastText}</small>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  };

  useEffect(() => {}, [registeredUser]);
  return (
    <>
      <Helmet>
        <title>Register for OneMap API Access | OneMap API</title>
        <meta
          name="description"
          content="Join the OneMap community by registering for API access. Share your project details and explore geospatial data tailored for business, education, and government. Sign up today!"
        />
      </Helmet>
      <div className="om-body container-fluid">
        <HeaderRegComponent />

        <div className="om-body-content pageBase">
          {toastText && <ToastComponent />}

          <div id="om-section-title" className="om-sections row">
            <h1>Registration</h1>
          </div>

          <Form className="form-inline" onSubmit={handleSubmit}>
            <div id="om-section-credentials" className="om-sections row">
              <div className="row">
                <Form.Group
                  id="om-reg-firstname"
                  className="col-md-6 mb-4"
                  controlId="firstname"
                >
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    pattern="^[a-zA-Z ]+$"
                    placeholder="First Name"
                    aria-errormessage="lettersOnlyErr"
                    required
                  />
                </Form.Group>

                <Form.Group
                  id="om-reg-lastname"
                  className="col-md-6 mb-4"
                  controlId="lastname"
                >
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    pattern="^[a-zA-Z ]+$"
                    placeholder="Last Name"
                    aria-errormessage="lettersOnlyErr"
                    required
                  />
                </Form.Group>
              </div>

              <div className="row">
                <Form.Group
                  id="om-reg-company"
                  className="col-md-6 mb-4"
                  controlId="company"
                >
                  <Form.Label>Company</Form.Label>
                  <Form.Control placeholder="Company" required />
                </Form.Group>

                <Form.Group
                  id="om-reg-email"
                  className="col-md-6 mb-4"
                  controlId="email"
                >
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" placeholder="Email" required />
                </Form.Group>
              </div>
            </div>

            <div id="om-section-usergroup" className="om-sections row">
              <div className="row">
                <span className="form-label">
                  User Group &#40;Choose only one&#41;
                </span>
              </div>

              <div className="row">
                <ul>
                  {UserGroupOptions.map((option, index) => {
                    return (
                      <li className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name={option.name}
                          id={`${option.name}-${option.value}`}
                          onChange={handleUserGroupChange}
                          defaultValue={option.value}
                          required
                          checked={selectedUserGroup === option.value}
                        />

                        <label htmlFor={`${option.name}-${option.value}`}>
                          {option.label}
                          {option.value === "business" ? labelChange : ""}
                        </label>
                      </li>
                    );
                  })}
                  <li className="form-check">
                    <FormGroup className="mb-3 col-2">
                      {showTextBox && (
                        <Form.Control
                          size="sm"
                          type="othersText"
                          value={otherUserGroupText}
                          onChange={othersTextChange}
                          required
                        />
                      )}
                    </FormGroup>
                  </li>
                </ul>
              </div>

              {showCard && (
                <div
                  id="om-section-usergroup-business-card"
                  key="card"
                  className="card"
                >
                  <Card.Body className="om-ug-subgrp">
                    <div className="row">
                      <span className="form-label">
                        Choose one industry below
                      </span>
                    </div>

                    <div className="row">
                      {subBusinessGroup.map((option, index) => {
                        return (
                          <div
                            className="om-ug-subgrp-items form-check"
                            key={`${option.name}${index}`}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              id={`${option.name}-${option.value}`}
                              name={`${option.name}-${option.value}`}
                              defaultValue={option.value}
                              onChange={subBusinessChange}
                              checked={selectedSubUserGroup === option.value}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${option.name}-${option.value}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        );
                      })}
                    </div>

                    <div className="row justify-content-end">
                      <Button
                        className="om-ug-subgrp-confirm"
                        onClick={() => {
                          if (selectedSubUserGroup === "")
                            showToastMessage("Please select an industry");
                          else saveUserGroupChange();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </Card.Body>
                </div>
              )}
            </div>

            <div id="om-section-applicationtype" className="om-sections row">
              <div className="row">
                <span className="form-label">
                  Which type of application are you developing?
                </span>
              </div>

              <div className="row">
                <ul>
                  {APIUsageOptions.map((option, index) => {
                    return (
                      <li className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name={option.name}
                          id={`${option.name}-${option.value}`}
                          onChange={APIUsageChange}
                          defaultValue={option.value}
                          required
                          checked={selectedAPI === option.value}
                        />

                        <label htmlFor={`${option.name}-${option.value}`}>
                          {option.label}
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div id="om-section-apiuse" className="om-sections row">
              <div className="row">
                <span className="form-label">
                  What is the proposed use of the data/API?
                </span>
              </div>

              <div className="row">
                <Form.Group className="col-md-8">
                  <Form.Control
                    as="textarea"
                    placeholder="Please describe what the API is used for."
                    defaultValue={APIUsageOthers}
                    id="usage"
                    maxLength={500}
                    rows="3"
                    required
                    onChange={APIUsageOthersChange}
                  />
                </Form.Group>
              </div>
            </div>

            <div id="om-section-knowonemap" className="om-sections row">
              <div className="row">
                <span className="form-label">
                  How did you learn about OneMap
                </span>
              </div>

              <div className="row">
                <ul>
                  {LearnOptions.map((option, index) => {
                    return (
                      <li className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name={option.name}
                          id={`${option.name}-${option.value}`}
                          onChange={LearnOptionsChange}
                          defaultValue={option.value}
                          required
                          checked={selectedLearn === option.value}
                        />

                        <label htmlFor={`${option.name}-${option.value}`}>
                          {option.label}
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <br />
            <br />

            <div id="om-section-agreement" className="om-sections row">
              <div className="row">
                <FormCheck
                  key="agreement"
                  id="ack"
                  className="om-btn-agreement col-12"
                  type="checkbox"
                  name="ack"
                  label={
                    <div>
                      By registering for an account, I acknowledge and accept
                      the{" "}
                      <a
                        className="om-links"
                        href="https://onemap.gov.sg/legal/privacystatement.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Statement
                      </a>
                      , Open Data Policy and{" "}
                      <a
                        className="om-links"
                        href="https://www.onemap.gov.sg/legal/apitermsofservice.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        API Terms Of Use
                      </a>
                      of OneMap. I also agree to receive information about
                      OneMap provided by Singapore Land Authority, including
                      (but not limited to) updates and notifications for OneMap
                      API.
                    </div>
                  }
                  onChange={ackChange}
                  value="ack"
                  feedback="You must agree before submitting"
                  feedbackType="invalid"
                  required
                />
              </div>

              <div className="row">
                <div className="inline-block text-center">
                  <Button className="om-btn-form-submit om-red" type="submit">
                    Register
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <FooterComponent />
      </div>
    </>
  );
};

export default Register;
